import { chakra } from "@chakra-ui/react";
import * as React from "react";

export const Logo = (props: any) => (
  <>
    <div>LOGO</div>
  </>
);
